import React from "react";
import "./Photos.css";

export default function Photos(props) {
    //Check if there are photos
    if (props.photos) {
        return (
            <section className="Photos section-photos">
                <div className="row">
                    {props.photos.map(function (photo, index) {
                        return (
                            <div className="col-4" key={index}>
                                <a href={photo.src.original} target="_blank" rel="noreferrer">
                                    <img src={photo.src.landscape} className="img-fluid" alt={photo.alt} />
                                </a>
                            </div>
                        );
                    })}
                </div>
            </section>
        );
        } else {
        return null;
  }
}